// ==============================|| OVERRIDES - FormControlLabel ||============================== //

export default function FormControlLabel() {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
  };
}
